import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles-wa/template_preview_modal.css';

const TemplatePreviewModal = ({
  isOpen,
  template,
  onClose,
  onSendTemplate,
  renderWhatsAppPreview,
  isFetchingContacts,
}) => {
  if (!isOpen || !template) return null;

  return createPortal(
    <div className="wa-module">
      <div className="template-preview-overlay">
      <div className="template-preview-modal">
        {/* Header */}
        <div className="preview-modal-header">
          <div className="preview-modal-title-section">
            <h2 className="preview-modal-title">{template.name}</h2>
            <div className="preview-modal-meta">
              <span className={`preview-status-badge status-${template.status?.toLowerCase()}`}>
                {template.status}
              </span>
              <span className={`preview-category-badge cat-${template.category?.toLowerCase()}`}>
                {template.category}
              </span>
              <span className="preview-language-badge">
                {template.language}
              </span>
            </div>
          </div>
          <button
            className="preview-modal-close"
            onClick={onClose}
            title="Close"
            aria-label="Close preview"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Preview Content */}
        <div className="preview-modal-content">
          <div className="preview-section">
            <label className="preview-section-label">Template Preview</label>
            <div className="preview-template-container">
              {renderWhatsAppPreview ? (
                renderWhatsAppPreview(template)
              ) : (
                <div className="preview-fallback">
                  <p>Preview not available</p>
                </div>
              )}
            </div>
          </div>

          {/* Template Details Grid */}
          <div className="preview-details-grid">
            {template.variables_count > 0 && (
              <div className="preview-detail-item">
                <span className="detail-label">Variables</span>
                <span className="detail-value">{template.variables_count}</span>
              </div>
            )}

            {template.buttons && template.buttons.length > 0 && (
              <div className="preview-detail-item">
                <span className="detail-label">Buttons</span>
                <span className="detail-value">{template.buttons.length}</span>
              </div>
            )}

            {template.created_at && (
              <div className="preview-detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">
                  {new Date(template.created_at).toLocaleDateString()}
                </span>
              </div>
            )}

            {template.updated_at && (
              <div className="preview-detail-item">
                <span className="detail-label">Updated</span>
                <span className="detail-value">
                  {new Date(template.updated_at).toLocaleDateString()}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Footer with Actions */}
        <div className="preview-modal-footer">
          <button className="preview-btn-secondary" onClick={onClose}>
            Close
          </button>
          <button 
            className="preview-btn-primary" 
            onClick={onSendTemplate}
            disabled={isFetchingContacts}
            style={isFetchingContacts ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
          >
            {isFetchingContacts ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="sync-icon-rotate">
                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 12c0-4.4 3.6-8 8-8 3.3 0 6.2 2 7.4 5M22 12c0 4.4-3.6 8-8 8-3.3 0-6.2-2-7.4-5" />
                </svg>
                Loading...
              </span>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                Send Template
              </>
            )}
          </button>
        </div>
      </div>
     </div>
    </div>,
    document.body
  );
};

export default TemplatePreviewModal;



